import React, { useState, useEffect } from 'react'
import Banner from './Banner'
import "./home.css";
import Slide from './Slide';
import { NavLink } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

export default function Maincomp() {

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulating an asynchronous data fetch
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }, []);
    
      if (isLoading) {
        return (
          <div className="cart_section">
            <div className="circle">
              <CircularProgress />
              <h2>Loading....</h2>
            </div>
          </div>
        );
      }

    return (
        <>
            <div className="home_section">
                <div className="banner_part">
                    <Banner />
                </div>
                <div className="slide_part">
                    <div className="left_slide">
                        <Slide title="Deal Of The Day"/>
                    </div>
                    <div className="container-fluid right_slide">
                        <h5>Festive latest launches</h5>
                        <img src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Jupiter/Launches/T3/DesktopGateway_CategoryCard2x_758X608_T3._SY608_CB639883570_.jpg" alt="rightimg" />
                        <NavLink href="#">see more</NavLink>
                    </div>
                </div>

                <Slide title="Today's Deal" />

                <div className="center_img">
                    <img src="https://m.media-amazon.com/images/G/31/AMS/IN/970X250-_desktop_banner.jpg" alt="" />
                </div>

                <Slide title="Best Seller" />
                <Slide title="Upto 80% off" />
            </div>
        </>
    )
}
